export default "__VITE_ASSET__DI_tX4LK__"